import { writable } from "svelte/store";

export const highlightFullScreen = writable(false);
